<template>
  <div class="detail">
    <!-- 面包屑 -->
    <div class="Breadcrumb">
      <img
        @click="$router.replace('/Layout/Home')"
        src="@img/icon/ui_home_page_0.png"
        alt
      />
      <a @click="$router.replace('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
      <a @click="$router.push('/Layout/videorack')">视频库 &nbsp;/ &nbsp;</a>
      <a class="active">视频观看</a>
    </div>
    <div class="main_box">
      <div class="detai_box">
        <div class="video_box">
          <video
            :src="videoifo.video ? videoifo.video : ''"
            :poster="videoifo.cover ? videoifo.cover : ''"
            controls
            controlslist="nodownload noremoteplayback"
            :disablePictureInPicture="true"
          ></video>
          <!-- <myvideo
            :videourl="videoifo.video"
            :poster="videoifo.cover"
            :fullscreen="true"
            :autoplay="true"
          /> -->
          <div class="video_title">{{ videoifo.name }}</div>
        </div>
        <div class="video_detail_box">
          <div class="text_box">
            <div class="text_title">{{ videoifo.name }}</div>
            <div class="text_introduce">
              {{ videoifo.profile }}
            </div>
          </div>
          <div class="video_category">
            <div class="video_category_title">分集</div>
            <div class="video_category_list">
              <div
                @click="getVideodetail(item, index)"
                v-for="(item, index) in videolist"
                :key="index"
                :class="
                  videoId == item.videoId
                    ? 'video_category_list_title'
                    : 'video_category_list_subtitle'
                "
              >
                <img
                  v-if="videoId == item.videoId"
                  src="@img/icon/ui_play_y.png"
                  alt=""
                />
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myvideo from "../../learnmodel/actiondetail/myvideo.vue";
export default {
  data() {
    return {
      videoId: "", //视频id
      videoifo: {},
      videolist: [],
    };
  },
  components: { myvideo },
  mounted() {
    this.videoId = this.$route.query.videoId;
    this.getVideo();
  },
  methods: {
    // 分集
    getVideodetail(item, index) {
      this.videoId=item.videoId;
      this.getVideo();
      // console.log("分集详情", item);
      // this.videoifo = item;
      // this.videoId = item.videoId;
    },
    // 接口
    getVideo() {
      this.$http
        .get("api/video/getAllVideo?videoId=" + this.videoId)
        .then((res) => {
          if (res.success) {
            this.videoifo = res.result;
            this.videolist = res.result.videos;
          } else {
            this.$message.error(res.message);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import url("~@styles/common.less");
.detail {
  .main_box {
    overflow: auto;
    height: calc(100vh - 200px);
    padding: 88px 106px;
  }
  .detai_box {
    display: flex;
    // justify-content: space-between;
    padding: 0 0 28px;
    border-bottom: 1px solid #7070704a;
    .video_box {
        margin-right: 30px;
      width: 1094px;
      video {
        width: 100%;
        height: 615px;
        border: 1px solid #707070;
      }
      .video_title {
        padding: 25px 0 0;
        font-size: 40px;
        font-weight: bold;
        line-height: 52px;
        color: #313131;
      }
    }
    .video_detail_box {
      width: 550px;
      font-weight: 400;
      .text_box {
        padding: 16px 13px;
        border: 1px solid #3131314d;
        border-radius: 5px;
        .text_title {
          font-size: 30px;
          color: #313131;
        }
        .text_introduce {
          padding: 10px 0 0;
          font-size: 22px;
          line-height: 40px;
          color: #31313179;
        }
      }
      .video_category {
        height: 422px;
        overflow: hidden;
        margin: 22px 0 0;
        padding: 13px 16px 40px;
        border: 1px solid #3131314d;
        border-radius: 5px;
        .video_category_title {
          font-size: 30px;
          color: #313131;
        }
        .video_category_list {
          padding: 3px 15px 0 0;
          height: 100%;
          overflow: auto;
          font-size: 22px;
          line-height: 22px;
          color: #313131;
          .video_category_list_title {
            display: flex;
            align-items: center;
            background: #fff1d1;
            border-radius: 5px;
            img {
              margin-right: 13px;
              width: 26px;
              height: 26px;
            }
          }
          .video_category_list_title,
          .video_category_list_subtitle {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin: 11px 0;
            padding: 0 17px;
            height: 50px;
            line-height: 50px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>